<script setup lang="ts">
defineProps<{
  visible: boolean
  originalTime: string
  originalInspector: string
  preferredTimeSlotLabels: string[]
  embedded: boolean
  isRescheduleMode: boolean
}>()
</script>

<template>
  <template v-if="visible">
    <div
      class="calendar-reschedule-meta-col calendar-reschedule-meta-col--original"
      :class="{ 'schedule-ctx--embedded': embedded, 'schedule-ctx--reschedule': isRescheduleMode }"
    >
      <div class="calendar-reschedule-meta-label">Original Scheduled Time:</div>
      <p v-if="originalTime" class="calendar-reschedule-meta-line">{{ originalTime }}</p>
      <p
        v-if="originalInspector"
        class="calendar-reschedule-meta-line calendar-reschedule-meta-line--name"
        :title="originalInspector"
      >
        {{ originalInspector }}
      </p>
    </div>

    <div
      class="calendar-reschedule-meta-divider"
      :class="{ 'schedule-ctx--embedded': embedded, 'schedule-ctx--reschedule': isRescheduleMode }"
      aria-hidden="true"
    />

    <div
      class="calendar-reschedule-meta-col calendar-reschedule-meta-col--preferred"
      :class="{ 'schedule-ctx--embedded': embedded, 'schedule-ctx--reschedule': isRescheduleMode }"
    >
      <div class="calendar-reschedule-meta-label">Preferred Time Slots:</div>
      <p
        v-for="(pt, pi) in preferredTimeSlotLabels"
        :key="`pref-${pi}`"
        class="calendar-reschedule-meta-line"
      >
        {{ pt }}
      </p>
    </div>
  </template>
</template>

<style scoped>
.calendar-reschedule-meta-col--original.schedule-ctx--embedded.schedule-ctx--reschedule {
  position: absolute;
  top: 424px;
  left: 16px;
  flex: none;
  width: 228px;
  min-width: 228px;
  max-width: 228px;
  padding: 0;
  box-sizing: border-box;
  z-index: 21;
}

.calendar-reschedule-meta-col--preferred.schedule-ctx--embedded.schedule-ctx--reschedule {
  position: absolute;
  top: 424px;
  left: 293px;
  right: 144px;
  flex: none;
  width: auto;
  min-width: 0;
  padding: 0;
  box-sizing: border-box;
  z-index: 21;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.calendar-reschedule-meta-divider.schedule-ctx--embedded.schedule-ctx--reschedule {
  position: absolute;
  left: 268px;
  bottom: 118px;
  width: 1px;
  min-width: 1px;
  max-width: 1px;
  height: 104px;
  min-height: 104px;
  max-height: 104px;
  background: #e0e0e0;
  align-self: auto;
  flex: none;
  z-index: 21;
  pointer-events: none;
}

.calendar-reschedule-meta-col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 24px;
}

.calendar-reschedule-meta-col--original {
  flex: 1 1 0;
  padding-left: 0;
  width: 228px;
  min-width: 228px;
  max-width: 228px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.calendar-reschedule-meta-col--preferred {
  flex: 1 1 0;
  padding-right: 0;
}

.calendar-reschedule-meta-col--original .calendar-reschedule-meta-label {
  width: 100%;
  min-width: 0;
  max-width: none;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  margin: 0;
  box-sizing: border-box;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: #000000;
  text-align: left;
}

.calendar-reschedule-meta-col--original .calendar-reschedule-meta-line {
  display: block;
  width: 227px;
  min-width: 227px;
  max-width: 227px;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-reschedule-meta-col--original .calendar-reschedule-meta-line--name {
  width: 227px;
  min-width: 227px;
  max-width: 227px;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-reschedule-meta-divider {
  flex-shrink: 0;
  width: 1px;
  align-self: stretch;
  min-height: 40px;
  background: #e0e0e0;
}

.calendar-reschedule-meta-label {
  margin: 0;
  font-family: SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: #000000;
}

.calendar-reschedule-meta-line {
  margin: 0;
  font-family: SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: #000000;
}
</style>
